// extracted by mini-css-extract-plugin
export var additional = "icons-module--additional--fc05e";
export var additionalButton = "icons-module--additionalButton--9d953";
export var additionalPopup = "icons-module--additionalPopup--16d7b";
export var additionalSection = "icons-module--additionalSection--4ca09";
export var fadeInAnimation = "icons-module--fadeInAnimation--e7295";
export var hide = "icons-module--hide--3e2e6";
export var icon = "icons-module--icon--09759";
export var itemDescription = "icons-module--itemDescription--f14fe";
export var itemName = "icons-module--itemName--71aad";
export var visible = "icons-module--visible--b486e";
export var wrapper = "icons-module--wrapper--86a98";